import React from 'react';
import GraphCard from '../components/GraphCard';
import './About2.css';

const About2: React.FC = () => (
  <main className="about2-page">
    <div className="about2-frame">
      <GraphCard />
    </div>
  </main>
);

export default About2;
